import * as React from 'react';

import type {Status} from 'nutshell-graphql-types';

import {appHistory} from '../../../../../history';

import type {AnalyticsStatus} from '../../types';

import type {PageType} from './types';

export function getFlashBannerType(status: AnalyticsStatus) {
    switch (status) {
        case 'CONFIGURED':
            return 'success';
        case 'NOT_WORKING':
            return 'error';
        case 'NEW_VERSION_AVAILABLE':
            return 'warning';
        case 'NEVER_CONFIGURED':
        default:
            return 'default';
    }
}

export function getStatusDescription(status: AnalyticsStatus): React.ReactElement<any> {
    switch (status) {
        case 'CONFIGURED':
            return <span>Tracking snippet is active</span>;
        case 'NEW_VERSION_AVAILABLE':
            return <span>Action needed: Update your snippet</span>;
        case 'NOT_WORKING':
            return <span>Something isn’t working right</span>;
        case 'NEVER_CONFIGURED':
        default:
            return <span>No site visits have been detected yet</span>;
    }
}

export function getCtaButtonText(pageType: PageType, status: Status): string {
    if (pageType !== 'chat') {
        return 'Configure your website';
    }

    switch (status) {
        case 'CONFIGURED':
        case 'NEVER_CONFIGURED':
            return 'Embed chat';
        case 'NOT_WORKING':
            return 'View tracking setup';
        default:
            return 'Set up domain';
    }
}

export function handleCtaButtonClick(
    pageType: PageType,
    status: Status,
    openModal: () => void,
    closePopover: () => void
): void {
    if (pageType !== 'chat') {
        appHistory.push('/setup/tracking-snippet');
    }

    switch (status) {
        case 'CONFIGURED':
        case 'NEVER_CONFIGURED':
            closePopover();
            openModal();
            break;
        case 'NOT_WORKING':
            appHistory.push('/setup/tracking-snippet');
            break;
        default:
            appHistory.push('/setup/domains');
    }
}
